import React, { useState, useEffect } from "react";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import RandomContent from '../Components/RandomContent';
import ConversionActions from '../Common/ConversionActions';
import { formatHtml } from "../Conversion/HtmlFormat";
import { GetRandomBlogPost, GetPageContentBySlug } from '../services/apiservice';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { htmlFormatterFAQ } from '../Seo/faqSchemas';

const HtmlFormatter = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });
    const [tabSpace, setTabSpace] = useState(2);
    const [randomPost, setRandomPost] = useState('');
    const [loadingPost, setLoadingPost] = useState(true);
    const [pageContent, setpageContent] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const handleBlogClick = () => navigate('/blog/:paramlink');

    const paramlink = location.pathname.split('/').filter(Boolean).pop();

    useEffect(() => {
        setInputData('');
        setOutputData('');
        setIsError(false);
        fetchRandomPost();
        GetPageContent();
    }, []);

    const handleFormat = () => {
        try {
            const formatted = formatHtml(inputData, tabSpace);
            setOutputData(formatted);
            setIsError(false);
        } catch (error) {
            setOutputData("Error formatting HTML");
            setIsError(true);
        }
    };

    const fetchRandomPost = async () => {
        setLoadingPost(true);
        try {
            const randomPostData = await GetRandomBlogPost();
            const jsonPostList = JSON.parse(randomPostData);
            setRandomPost(jsonPostList);
            setLoadingPost(false);
        } catch (error) {
            setLoadingPost(false);
            console.error('Error fetching the data:', error);
        }
    };

    const GetPageContent = async () => {
        try {
            const postMetaList = await GetPageContentBySlug(paramlink);
            const jsonMetaList = JSON.parse(postMetaList);
            setpageContent(jsonMetaList);
        } catch (error) {
            console.error('Error fetching page content:', error);
        }
    };

    return (
        <>
            <div>
                <Header />

                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(htmlFormatterFAQ)}
                    </script>
                </Helmet>

                <RandomContent />

                {/* Intro Section */}
                <div className="blog-area">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">
                            <div className="full-col col-lg-12 col-md-12">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="details">
                                        <h4><a href="#">{pageContent?.section1header}</a></h4>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    pageContent?.section1text && pageContent.section1text.trim() !== ''
                                                        ? pageContent.section1text
                                                        : `Beautify your HTML code effortlessly with Data Beautifier's Free HTML Formatter Online Tool.
                                            Our Best HTML Formatter Online Tool enhances code readability by organizing and structuring your HTML files efficiently.
                                            Whether you're a seasoned developer or a beginner, our Simple HTML Formatter Tool is designed for ease of use,
                                            requiring no prior expertise. With the Easy HTML Formatter Tool, you can format messy HTML code in seconds,
                                            ensuring clean and professional results every time. Available 24/7 and free of charge,
                                            Data Beautifier is the ultimate solution for optimizing your HTML formatting needs.
                                            Try it today for hassle-free results!`,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Input / Button / Output Section */}
                <div className="blog-area pb-20">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">

                            {/* Input Box */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="thumb">
                                        <Inputs
                                            value={inputData}
                                            setValue={(val) => {
                                                setInputData(val);
                                                setIsError(false);
                                            }}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            isError={isError}
                                            lineCol={inputLnCol}
                                            setLineCol={setInputLnCol}
                                            readOnly={false}
                                            idPrefix="input"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Conversion Actions */}
                            <ConversionActions
                                tabSpace={tabSpace}
                                setTabSpace={setTabSpace}
                                handleConversion={handleFormat}
                                outputData={outputData}
                                randomPost={randomPost}
                                loadingPost={loadingPost}
                                handleBlogClick={handleBlogClick}
                                buttonLabel="Format HTML"
                                iconClass="ri-braces-line"
                            />

                            {/* Output Box */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                                    <div className="thumb">
                                        <Output
                                            value={outputData}
                                            setValue={setOutputData}
                                            lineCol={outputLnCol}
                                            setLineCol={setOutputLnCol}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            isError={isError}
                                            readOnly={true}
                                            idPrefix="output"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Bottom CMS Section */}
                {pageContent?.section2text && pageContent.section2text.trim() !== '' && (
                    <div className="blog-area">
                        <div className="container-block-fluid">
                            <div className="row justify-content-center">
                                <div className="full-col col-lg-12 col-md-12">
                                    <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                        <div
                                            className="details"
                                            dangerouslySetInnerHTML={{ __html: pageContent.section2text }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Section 3 Below Boxes */}
                {pageContent?.section3text &&
                    pageContent.section3text.trim() !== "" && (
                        <div className="blog-area">
                            <div className="container-block-fluid">
                                <div className="row justify-content-center">
                                    <div className="full-col col-lg-12 col-md-12">
                                        <div
                                            className="single-blog-inner"
                                            data-aos="fade-up"
                                            data-aos-duration="2800"
                                        >
                                            <div className="details">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: pageContent.section3text,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

            </div>

            <Footer />
        </>
    );
};

export default HtmlFormatter;
